import { api } from '@/services/api/main/axios';
import config from '@/config';

export interface LoginForm {
  email: string;
  password: string;
  rememberMe: boolean;
  recaptchaResponse?: string;
}

export const loginApiRequest = async (loginForm: LoginForm) => {
  return api.post('auth/login', {
    ...loginForm,
    site_id: config.api.site_id,
  });
};
